export const wellnessFaqArray = [
  {
    question: 'What is wellness coaching?',
    answer:
      'Wellness coaching is a supportive process that helps you shift your mindset, create healthier habits, and design a lifestyle that feels balanced and fulfilling.',
  },
  {
    question: 'How do sessions take place?',
    answer:
      'You can choose between online sessions (video call) or in-person meetings in Drammen, Norway. Group coaching is also available.',
  },
  {
    question: 'What is included in the coaching plan?',
    answer:
      'Each plan includes tailored guidance, weekly check-ins, and practical tools to support stress relief, clarity, and lifestyle changes.',
  },
  {
    question: 'How much does it cost?',
    answer:
      'Coaching is priced at 2500 kr per month, which includes weekly check-ins and ongoing support throughout the program.',
  },
  {
    question: 'Do I need prior experience with coaching?',
    answer:
      'Not at all. Coaching is for anyone ready to grow. Whether you are new to personal development or already experienced, the sessions are tailored to your level and goals.',
  },
  {
    question: 'What kind of results can I expect?',
    answer:
      'Clients often experience reduced stress, improved focus, and a greater sense of balance and confidence in their daily lives.',
  },
];